<template>
    <!-- https://www.youtube.com/watch?v=zOtxP7ahi4M -->

    <!-- Navbar -->

    <nav class="navbar navbar-expand-lg fixed-top w-100">

        <div class="container">

            <!-- Logo -->
            <router-link to="/" class="navbar-brand p-0">
                <img src="@/assets/images/navbar/logo.webp" alt="ThakaaHoldingLogo" />
            </router-link>

            <!-- Toggle Button -->
            <button class="navbar-toggler shadow-none border-0" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                <!-- <span class="navbar-toggler-icon"></span> -->
                <font-awesome-icon :icon="['fas', 'fa-bars']" />
            </button>

            <!-- Sidebar -->
            <div class="sidebar offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel">

                <!-- Sidebar Header -->
                <div class="offcanvas-header border-bottom">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
                        <img src="@/assets/images/navbar/logo.webp" alt="ThakaaHoldingLogo" />
                    </h5>
                    <!-- btn-close -->
                    <button type="button" class="shadow-none border-0" data-bs-dismiss="offcanvas" aria-label="Close">
                        <font-awesome-icon :icon="['fas', 'fa-xmark']" />
                    </button>
                </div>

                <!-- Sidebar Body -->
                <div class="offcanvas-body d-flex flex-column flex-lg-row p-4 p-lg-0">

                    <ul class="navbar-nav justify-content-center align-items-center flex-grow-1 pe-3">

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'home' }" class="nav-link" aria-current="page"
                                exact>الرئيسية</router-link>
                        </li>

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'about' }" class="nav-link">من نحن</router-link>
                        </li>

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'service' }" class="nav-link">الخدمات</router-link>
                        </li>

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'project' }" class="nav-link">المشاريع</router-link>
                        </li>

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'partner' }" class="nav-link">شركاؤنا</router-link>
                        </li>

                        <li class="nav-item mx-2">
                            <router-link :to="{ name: 'picture' }" class="nav-link">الصور</router-link>
                        </li>

                    </ul>

                    <div class="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                        <!-- mt-2 mt-lg-0 -->
                        <!--   -->
                        <router-link :to="{ name: 'contact_us' }"
                            class="btn d-flex justify-content-center align-items-center">
                            اتصل بنا
                            <font-awesome-icon :icon="['fas', 'fa-phone']" class="me-3" />
                        </router-link>
                    </div>

                </div>

            </div>

            <!-- End Sidebar -->

        </div>

        <!-- End Container wrapper -->

    </nav>
</template>

<script>

export default {

    name: 'Navbar',

    // https://www.youtube.com/watch?v=gbmV2Lh9dBM
    mounted() {
        document.addEventListener('scroll', ()=>{
            const myNav = document.querySelector('nav');
            if (window.scrollY>0) {
                myNav.classList.add('scrolled');
            } else {
                myNav.classList.remove('scrolled');
            }
        })
    },

}

</script>

<style scoped lang="scss">
nav {

    background-color: transparent;

    /* -webkit-transition: background-color 0.15s ease-in-out;
    -moz-transition: background-color 0.15s ease-in-out;
    -o-transition: background-color 0.15s ease-in-out;
    -ms-transition: background-color 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out; */

    // width: 100%;
    height: 72px;
    padding-top: 16px;

    @include breakpoints(x-small) {
        // background-color: $Black;
        background-color: $Nav-BG;
        height: 88px;
        padding-bottom: 16px;
    }

    @include breakpoints(small) {
        // background-color: $Black;
        background-color: $Nav-BG;
        height: 88px;
        padding-bottom: 16px;
    }

    @include breakpoints(medium) {
        // background-color: $Black;
        background-color: $Nav-BG;
        height: 88px;
        padding-bottom: 16px;
    }

    .container {

        .navbar-brand {
            img {
                width: 110.741px;
                height: 56px;
            }
        }

        .navbar-toggler {
            svg {
                color: $Green;
                width: 24px;
                height: 24px;
            }
        }

        .offcanvas {

            @include breakpoints(x-small) {
                background-color: $Black;
                // background-color: $Nav-BG;
                // backdrop-filter: blur(10px);
            }

            @include breakpoints(small) {
                background-color: $Black;
                // background-color: $Nav-BG;
                // backdrop-filter: blur(10px);
            }

            @include breakpoints(medium) {
                background-color: $Black;
                // background-color: $Nav-BG;
                // backdrop-filter: blur(10px);
            }

            .offcanvas-header {

                h5 {
                    img {
                        width: 110.741px;
                        height: 56px;
                    }
                }

                button {
                    background: none;
                    color: $Green;
                    font-size: 24px;
                }

            }

            .offcanvas-body {

                ul {

                    li {

                        @include breakpoints(x-small) {
                            width: 100%;
                            border-bottom: 1px solid $Gry;
                        }

                        @include breakpoints(small) {
                            width: 100%;
                            border-bottom: 1px solid $Gry;
                        }

                        @include breakpoints(medium) {
                            width: 100%;
                            border-bottom: 1px solid $Gry;
                        }

                        a {
                            color: $White;
                            // font-size: 16px;
                            font-size: 18px;
                            // font-weight: 400;
                            // text-align: right;
                            line-height: 180%;

                            @include breakpoints(x-small) {
                                text-align: center;
                            }

                            @include breakpoints(small) {
                                text-align: center;
                            }

                            @include breakpoints(medium) {
                                text-align: center;
                            }
                        }

                        a:hover,
                        a.router-link-exact-active {
                            // font-family:'FFShamelFamily-Bold';
                            color: $Green;
                        }

                    }

                }

                ul::after {
                    border-bottom: 1px solid $Gry;
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 15px;
                    width: 545px;
                    bottom: 0;
                    margin: 0 auto;
                }

                div {

                    a {
                        width: 129px;
                        /* height: 40px; */
                        padding: 6px 8px;
                        border-radius: 8px;
                        border: 1px solid $Green;

                        font-size: 18px;
                        line-height: 180%;

                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;

                        svg {
                            color: $Green;
                            font-size: 18px;
                        }
                    }

                }

            }

        }

    }

}
nav.scrolled{
    background-color: $Nav-BG;
}
</style>